<template>
    <div>
        <!-- Modal -->
        <div
            class="modal fade"
            id="seeAnswerModal"
            role="dialog"
        >
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">{{ askInModal.title }}</h5>
                        <button type="button" class="close" data-dismiss="modal">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <span class="badge badge-success">Sentimento Positivo</span>
                        <span class="badge badge-danger">Sentimento Negativo</span>
                        <span class="badge badge-info">Neutro</span><br><br>
                        <h5 class='mb-5'>Respostas: </h5>
                        <div v-for="answer in askInModal.answer_essays" :key="answer.id">
                            <p>{{ answer.answer }}</p>

                            
                            <div class="progress">
                                <div class="progress-bar bg-success" role="progressbar" :style="{width: convertInPercent(answer.sentiment_positive)+'%'}" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100">{{convertInPercent(answer.sentiment_positive)}}%</div>
                                <div class="progress-bar bg-danger" role="progressbar" :style="{width: convertInPercent(answer.sentiment_negative)+'%'}" aria-valuenow="15" aria-valuemin="0" aria-valuemax="100">{{convertInPercent(answer.sentiment_negative)}}%</div>
                                <div class="progress-bar bg-info" role="progressbar" :style="{width: convertInPercent(answer.sentiment_neutral)+'%'}" aria-valuenow="30" aria-valuemin="0" aria-valuemax="100">{{convertInPercent(answer.sentiment_neutral)}}%</div>
                            </div>
                            <hr>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-if="research.anonymity_level !== 2">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <div class="card-title">Escala</div>
                    </div>
                    <div class="card-body">
                        <horizontal-bar
                            v-if="responseFrequencyData.datasets.length"
                            :chart-data="responseFrequencyData"
                            :styles="responseFrequencyStyle"
                            :options="chartOptions.responseFrequency"
                        ></horizontal-bar>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <div class="card-title">Ranking</div>
                    </div>
                    <div class="card-body">
                        <div
                            class="row"
                            v-if="rankingAsks.length && Object.keys(rankingDatas).length > 0"
                        >
                            <div v-for="ask in rankingAsks" :key="ask.id" class="col-6">
                                <h5>{{ ask.title }}</h5>
                                <horizontal-bar
                                    :chart-data="rankingDatas[ask.id]"
                                    :styles="alternativesStyle"
                                    :options="rankingOptions.responseFrequency"
                                ></horizontal-bar>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <div class="card-title">Alternativas</div>
                    </div>
                    <div class="card-body">
                        <div
                            class="row"
                            v-if="alternativeAsks.length && Object.keys(alternativesDatas).length > 0"
                        >
                            <div v-for="ask in alternativeAsks" :key="ask.id" class="col-6">
                                <h5>{{ ask.title }}</h5>
                                <horizontal-bar
                                    :chart-data="alternativesDatas[ask.id]"
                                    :styles="alternativesStyle"
                                    :options="chartOptions.alternatives"
                                ></horizontal-bar>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <div
                            class="card-title"
                        >Dissertativa - Análise de sentimento por Inteligência Artificial (BETA)</div>
                    </div>
                    <div class="card-body">
                        <div
                            class="row"
                            v-if="essayAsks.length && Object.keys(essayIADatas).length > 0"
                        >
                            <div v-for="ask in essayAsks" :key="ask.id" class="col-6">
                                <div class="row">
                                    <div class="col-md-12">
                                        <h5>{{ ask.title }}</h5>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <button
                                            v-if="$store.getters.user.type_id == 1"
                                            class="btn btn-normal-slim float-left"
                                            @click="seeAnswers(ask)"
                                        >
                                            Visualizar respostas
                                            <i class="fa fa-eye"></i>
                                        </button>
                                    </div>
                                </div>
                                <horizontal-bar
                                    :chart-data="essayIADatas[ask.id]"
                                    :styles="alternativesStyle"
                                    :options="chartOptions.alternatives"
                                ></horizontal-bar>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Bar from "../Charts/Bar.js";
import HorizontalBar from "../Charts/HorizontalBar.js";
export default {
    data() {
        return {
            askInModal: {},
            mainColors: [
                "#55efc4", //Green#ff5e3b
                "#a29bfe", //Purple
                "#ffeaa7", //Yellow
                "#ff7675", //Red
                "#74b9ff",
                "#f0b0a0"
            ],
            colors: {
                0: "#ff0000", //Red
                1: "#FD8804", //Green
                2: "#D3D000", //Green
                3: "#7EBD0C", //Purple
                4: "#42C516"
            },
            chartOptions: {
                responseFrequency: {
                    responsive: true,
                    maintainAspectRatio: false,
                    tooltips: {
                        enabled: true,
                        callbacks: {
                            label: function(tooltipItem, data) {
                            var allData = data.datasets[tooltipItem.datasetIndex].data;
                            var tooltipLabel = data.labels[tooltipItem.index];
                            var tooltipData = allData[tooltipItem.index];
                            return tooltipLabel + ": " + tooltipData + "%";
                            }
                        }                          
                    },
                    hover: {
                        animationDuration: 30
                    },
                    scales: {
                        xAxes: [
                            {
                                ticks: {
                                    beginAtZero: true,
                                    fontFamily: "'Open Sans Bold', sans-serif",
                                    fontSize: 11,
                                    callback: function(value, index, values) {
                                    return value + '%';
                                    }
                                },
                                scaleLabel: {
                                    display: false
                                },
                                gridLines: {},
                                stacked: true
                            }
                        ],
                        yAxes: [
                            {
                                gridLines: {
                                    display: false,
                                    color: "red",
                                    zeroLineColor: "red",
                                    zeroLineWidth: 0
                                },
                                ticks: {
                                    fontFamily: "'Open Sans Bold', sans-serif",
                                    fontSize: 13,
                                    fontStyle: "bold"
                                },
                                stacked: true
                            }
                        ]
                    },
                    legend: {
                        display: true
                    },

                    pointLabelFontFamily: "Quadon Extra Bold",
                    scaleFontFamily: "Quadon Extra Bold"
                },
                alternatives: {
                    responsive: true,
                    maintainAspectRatio: false,
                    tooltips: {
                        enabled: true,
                        callbacks: {
                            label: function(tooltipItem, data) {
                            var allData = data.datasets[tooltipItem.datasetIndex].data;
                            var tooltipLabel = data.labels[tooltipItem.index];
                            var tooltipData = allData[tooltipItem.index];
                            return tooltipLabel + ": " + tooltipData + "%";
                            }
                        }                          
                    },
                    scales: {
                        xAxes: [
                            {
                                ticks: {
                                    beginAtZero: true,
                                    callback: function(value, index, values) {
                                    return value + '%';
                                    }
                                }
                            }
                        ],
                        yAxes: [
                            {
                                stacked: false,
                                afterFit: function(scaleInstance) {
                                    scaleInstance.width = 250; // sets the width to 100px
                                },
                                ticks: {
                                    fontSize: 13,
                                    fontStyle: "bold"
                                }
                            }
                        ]
                    },
                    legend: {
                        display: false,
                        boxWidth: "30%"
                    }
                }
            },
            rankingOptions: {
                responseFrequency: {
                    responsive: true,
                    maintainAspectRatio: false,
                    tooltips: {
                        enabled: true,
                        callbacks: {
                            label: function(tooltipItem, data) {
                            var allData = data.datasets[tooltipItem.datasetIndex].data;
                            var tooltipLabel = data.labels[tooltipItem.index];
                            var tooltipData = allData[tooltipItem.index];
                            return tooltipLabel + ": " + tooltipData + "%";
                            }
                        }                       
                    },
                    hover: {
                        animationDuration: 30
                    },
                    scales: {
                        xAxes: [
                            {
                                ticks: {
                                    beginAtZero: true,
                                    fontFamily: "'Open Sans Bold', sans-serif",
                                    fontSize: 11,
                                    max: 100,
                                    callback: function(value, index, values) {
                                    return value + '%';
                                    }
                                },
                                scaleLabel: {
                                    display: false,
                                },
                                gridLines: {},
                                stacked: true
                            }
                        ],
                        yAxes: [
                            {
                                gridLines: {
                                    display: false,
                                    color: "red",
                                    zeroLineColor: "red",
                                    zeroLineWidth: 0
                                },
                                ticks: {
                                    fontFamily: "'Open Sans Bold', sans-serif",
                                    fontSize: 13,
                                    fontStyle: "bold"
                                },
                                stacked: true
                            }
                        ]
                    },
                    legend: {
                        display: true,
                    },

                    pointLabelFontFamily: "Quadon Extra Bold",
                    scaleFontFamily: "Quadon Extra Bold"
                }
            }
        };
    },
    computed: {
        alternativeAsks() {
            const self = this;
            return self.research.asks.filter(ask => ask.type_id == 2);
        },
        rankingAsks() {
            const self = this;
            return self.research.asks.filter(ask => ask.type_id == 4);
        },
        essayAsks() {
            const self = this;
            return self.research.asks.filter(ask => ask.type_id == 3);
        },
        responseFrequencyData() {
            const self = this;
            let labels = [];
            let datasets = [];
            self.research.asks.forEach((ask, index) => {
                if (ask.type_id == 1) {
                    labels.push("");
                    labels.push(ask.title);
                    labels.push("(Empresa)");
                    labels.push("(Departamento)");

                    let countersEmpty = {
                        0: 0,
                        1: 0,
                        2: 0,
                        3: 0,
                        4: 0
                    };
                    for (let indexCounterEmpty in countersEmpty) {
                        if (!datasets[indexCounterEmpty]) {
                            datasets.push({
                                data: [],
                                backgroundColor: self.convertHex(
                                    self.colors[indexCounterEmpty],
                                    100
                                ),
                                // borderColor: self.convertHex(
                                //     self.colors[indexCounterEmpty],
                                //     100
                                // ),
                                borderWidth: "2",
                                barThickness: 30,
                                label: self.getScaleName(indexCounterEmpty)
                            });
                        }

                        datasets[indexCounterEmpty].data.push("");
                        datasets[indexCounterEmpty].data.push("");
                    }

                    let countersCompany = {
                        0: 0,
                        1: 0,
                        2: 0,
                        3: 0,
                        4: 0
                    };
                    let totalCounterCompany = 0;
                    let counterPercentagesCompany = {
                        0: 0,
                        1: 0,
                        2: 0,
                        3: 0,
                        4: 0
                    };

                    ask.answer_scales.forEach(answer => {
                        totalCounterCompany++;
                        countersCompany[answer.company]++;
                    });

                    for (let indexCounterCompany in countersCompany) {
                        counterPercentagesCompany[indexCounterCompany] =
                            (countersCompany[indexCounterCompany] * 100) /
                            totalCounterCompany;

                        if (!datasets[indexCounterCompany]) {
                            datasets.push({
                                data: [],
                                backgroundColor: self.convertHex(
                                    self.colors[indexCounterCompany],
                                    5
                                ),
                                borderColor: self.convertHex(
                                    self.colors[indexCounterCompany],
                                    100
                                ),
                                // backgroundColor: "rgba(163,"+indexCounterCompany+",126,1)",
                                // hoverBackgroundColor: "rgba(140,"+indexCounterCompany+",100,1)",
                                borderWidth: "2",
                                label: indexCounterCompany,
                                barThickness: 2
                                // hoverBackgroundColor: "rgba(50,90,100,1)"
                            });
                        }
                        datasets[indexCounterCompany].data.push(
                            counterPercentagesCompany[indexCounterCompany]
                                ? counterPercentagesCompany[
                                      indexCounterCompany
                                  ].toFixed(2)
                                : ""
                        );
                    }

                    let countersDepartment = {
                        0: 0,
                        1: 0,
                        2: 0,
                        3: 0,
                        4: 0
                    };
                    let totalCounterDepartment = 0;
                    let counterPercentagesDepartment = {
                        0: 0,
                        1: 0,
                        2: 0,
                        3: 0,
                        4: 0
                    };

                    ask.answer_scales.forEach(answer => {
                        totalCounterDepartment++;
                        countersDepartment[answer.department]++;
                    });

                    for (let indexCounterDepartment in countersDepartment) {
                        counterPercentagesDepartment[indexCounterDepartment] =
                            (countersDepartment[indexCounterDepartment] * 100) /
                            totalCounterDepartment;

                        if (!datasets[indexCounterDepartment]) {
                            datasets.push({
                                data: [],
                                backgroundColor: self.convertHex(
                                    self.colors[indexCounterDepartment],
                                    5
                                ),
                                borderColor: self.convertHex(
                                    self.colors[indexCounterDepartment],
                                    100
                                ),
                                borderWidth: "2",
                                label: indexCounterDepartment,
                                barThickness: 2
                            });
                        }
                        datasets[indexCounterDepartment].data.push(
                            counterPercentagesDepartment[indexCounterDepartment]
                                ? counterPercentagesDepartment[
                                      indexCounterDepartment
                                  ].toFixed(2)
                                : ""
                        );
                    }
                }
            });
            return {
                labels: labels,

                datasets: datasets
            };
        },
        essayIADatas() {
            const self = this;

            let askAnswers = {};
            let graphsColorCounter = 0;

            self.research.asks.forEach(ask => {
                if (ask.type_id == 3) {
                    if (graphsColorCounter > 4) {
                        graphsColorCounter = 0;
                    }

                    let labels = ["Positivo", "Neutro", "Negativo"];
                    let dataset = {
                        data: [],
                        backgroundColor: self.mainColors[graphsColorCounter]
                    };

                    let sentimentAnswers = {
                        positive: 0,
                        neutral: 0,
                        negative: 0
                    };

                    let totalAnswers = 0;

                    ask.answer_essays.forEach(answer => {
                        if (answer.IA_analysed) {
                            totalAnswers++;
                            sentimentAnswers.positive +=
                                answer.sentiment_positive;
                            sentimentAnswers.neutral +=
                                answer.sentiment_neutral;
                            sentimentAnswers.negative +=
                                answer.sentiment_negative;
                        }
                    });

                    for (let sentiment in sentimentAnswers) {
                        dataset.data.push(
                            sentimentAnswers[sentiment]
                                ? (
                                      (sentimentAnswers[sentiment] /
                                          totalAnswers) *
                                      100
                                  ).toFixed(2)
                                : ""
                        );
                    }

                    askAnswers[ask.id] = {
                        labels: labels,
                        datasets: [dataset]
                    };

                    graphsColorCounter++;
                }
            });
            return askAnswers;
        },
        rankingDatas() {
            
            const self = this;

            let askAnswers = {};

            let graphsColorCounter = 0;

            self.research.asks.forEach(ask => {
                if (ask.type_id == 4) {
                    if (graphsColorCounter > 4) {
                        graphsColorCounter = 0;
                    }
                    let labels = [];
                    let dataset = {
                        data: [],
                        backgroundColor: self.mainColors[graphsColorCounter]
                    };

                    let optionAnswers = {};

                    ask.options.forEach(option => {
                        labels.push(option.description);
                        optionAnswers[option.id] = 0;
                    });

                    let totalAnswers = 0;

                    ask.answer_ranking.forEach(answer => {
                        totalAnswers++;
                        optionAnswers[answer.option_id]++;
                    });

                    for (let optionId in optionAnswers) {
                        dataset.data.push(
                            optionAnswers[optionId]
                                ? (
                                      (optionAnswers[optionId] * 100) /
                                      totalAnswers
                                  ).toFixed(2)
                                : ""
                        );
                    }

                    askAnswers[ask.id] = {
                        labels: labels,
                        datasets: [dataset]
                    };

                    graphsColorCounter++;
                }
            });
            return askAnswers;
        },
        alternativesDatas() {
            const self = this;

            let askAnswers = {};

            let graphsColorCounter = 0;

            self.research.asks.forEach(ask => {
                if (ask.type_id == 2) {
                    if (graphsColorCounter > 4) {
                        graphsColorCounter = 0;
                    }
                    let labels = [];
                    let dataset = {
                        data: [],
                        backgroundColor: self.mainColors[graphsColorCounter]
                    };

                    let optionAnswers = {};

                    ask.options.forEach(option => {
                        labels.push(option.description);
                        optionAnswers[option.id] = 0;
                    });

                    let totalAnswers = 0;

                    ask.answer_alternatives.forEach(answer => {
                        totalAnswers++;
                        optionAnswers[answer.option_id]++;
                    });

                    for (let optionId in optionAnswers) {
                        dataset.data.push(
                            optionAnswers[optionId]
                                ? (
                                      (optionAnswers[optionId] * 100) /
                                      totalAnswers
                                  ).toFixed(2)
                                : ""
                        );
                    }

                    askAnswers[ask.id] = {
                        labels: labels,
                        datasets: [dataset]
                    };

                    graphsColorCounter++;
                }
            });
            return askAnswers;
        },
        responseFrequencyStyle() {
            const self = this;
            let scaleAsksCounter = 0
            self.research.asks.forEach(ask => {
                if(ask.type_id == 1){
                    scaleAsksCounter++
                }
            })
            return {
                // width: `100%`,
                height: `${scaleAsksCounter * 180 + 100}px`
            };
        },
        alternativesStyle() {
            const self = this;
            return {
                width: `100%`
                // height: `${self.research.asks.length * 10}px`
            };
        }
    },
    methods: {
        convertInPercent(value) {
            return value * 100
        },
        getScaleName(value) {
            return value + " - " + this.research[`scale-label-${value}`];
        },
        seeAnswers(ask){
            $('#seeAnswerModal').modal('show')
            this.askInModal = ask
        },
        convertHex(hex, opacity) {
            hex = hex.replace("#", "");
            const r = parseInt(hex.substring(0, 2), 16);
            const g = parseInt(hex.substring(2, 4), 16);
            const b = parseInt(hex.substring(4, 6), 16);

            const result =
                "rgba(" +
                r +
                "," +
                g +
                "," +
                b +
                (opacity ? "," + opacity / 100 : "") +
                ")";
            return result;
        }
    },
    mounted: function() {
        const self = this;
    },
    components: {
        Bar,
        HorizontalBar
    },
    props: ["research"]
};
</script>


// WEBPACK FOOTER //
// src/components/Reusable/ResearchAnswerCharts.vue